<!-- 作文题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select">
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                <div class="count_num" v-if="getCompositionCount()">{{ `*
                    要求：字数要求为${getCompositionCount()?.minWordCount + '~' + getCompositionCount()?.maxWordCount}字` }}</div>
                <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div>
                <div class="mt-10" v-if="isShowScoring || topicInfo.showAnalysis">
                    <!-- <div v-html="$Tools.handlerImg(topicInfo.doAnswer)" v-mathml></div> -->
                    <!-- <div v-if="topicInfo.doAnswer.content">
                        <el-input class="input_title" v-model="topicInfo.doAnswer.title" size="large"
                            style="width: 100%;margin: 10px auto;border: none;" maxlength="15"
                            placeholder="请输入作文标题（2~15个字）" @input="handleTextInput" disabled />
                        <el-input class="input_content" v-model="topicInfo.doAnswer.content" size="large"
                            style="width: 100%;margin: 10px auto;border: none;"
                            :maxlength="getCompositionCount().maxWordCount" placeholder="请输入作文标题（2~15个字）"
                            type="textarea" show-word-limit :autosize="{ minRows: 20 }" @input="handleTextInput" disabled />
                    </div>
                    <div class="flex Flexalign" v-else>
                         <el-image class="mr-20 composition_image" v-for="(item,index) in topicInfo.doAnswer.image" :key="index" :src="imgPath(item)"></el-image>
                    </div> -->
                </div>
                <div class="mt-10" v-else>
                    <!-- <quillEditor :model-value="topicInfo.doAnswer" @update:model-value="getAnswer"></quillEditor> -->
                    <el-tabs v-model="activeTab" type="card" :before-leave="beforeTabLeave">
                        <el-tab-pane label="文本" name="text">
                            <el-input class="input_title" v-model="topicInfo.doAnswer.title" size="large"
                                style="width: 100%;margin: 10px auto;border: none;" maxlength="15"
                                placeholder="请输入作文标题（2~15个字）" @input="handleTextInput" />
                            <el-input class="input_content" v-model="topicInfo.doAnswer.content" size="large"
                                style="width: 100%;margin: 10px auto;border: none;" :maxlength="1200"
                                placeholder="请输入作文内容" type="textarea" show-word-limit :autosize="{ minRows: 20 }"
                                @input="handleTextInput" />
                        </el-tab-pane>
                        <el-tab-pane label="图片" name="image">
                            <el-upload v-model:file-list="topicInfo.doAnswer.imageList" :action="uploadUrl"
                                list-type="picture-card" :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove" :limit="3">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div class="mt-10 upload_tips">最多上传3张</div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <div>
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="top_answer p-20" v-if="getIsShow(1) || showAnswer">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>得分：{{ topicInfo.score || topicInfo.questionScore || 0 }}</div>
                    </div>
                    <div class="answer_top flex FlexBetween mt-10">
                        <div>参考答案：</div>
                        <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.questionContext?.answer)" v-mathml>
                        </div>
                    </div>
                    <div class="answer_top mt-10">
                        <div class="user_answer">你的答案：
                            <div class="bg_line"></div>
                        </div>
                        <!-- <div class="flex-1" v-html="$Tools.handlerImg(topicInfo.questionContext?.doAnswer)" v-mathml>
                        </div> -->
                        <div v-if="JSON.parse(topicInfo.questionContext?.doAnswer).content">
                            <el-input class="input_title" :value="JSON.parse(topicInfo.questionContext?.doAnswer).title"
                                size="large" style="width: 100%;margin: 10px auto;border: none;" maxlength="15"
                                placeholder="" @input="handleTextInput" disabled />
                            <el-input class="input_content"
                                :value="JSON.parse(topicInfo.questionContext?.doAnswer).content" size="large"
                                style="width: 100%;margin: 10px auto;border: none;" placeholder="" type="textarea"
                                show-word-limit :autosize="{ minRows: 20 }" @input="handleTextInput" disabled />
                        </div>
                        <div class="flex Flexalign" v-else>
                            <el-image class="mr-20 composition_image"
                                v-for="(item, index) in JSON.parse(topicInfo.questionContext?.doAnswer).image"
                                :key="index" :src="imgPath(item)"></el-image>
                        </div>
                    </div>
                </div>
                <div class="top_answer p-20 mt-20" v-if="getIsShow(2) || getIsShow(3) || showAnswer">
                    <div class="question_analyze mar_top_10" v-if="getIsShow(2) || showAnswer">【试题分析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-if="getIsShow(2)"
                        v-mathml>
                    </div>
                    <div class="question_analyze mar_top_10" v-if="getIsShow(3) || showAnswer">【解析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)"
                        v-if="getIsShow(3) || showAnswer" v-mathml></div>
                </div>
            </div>
        </div>
        <div class="marker_info" v-if="topicInfo.markerComment">
            <div class="marker_label mb-10">题目批语：</div>
            <div v-html="$Tools.handlerImg(topicInfo.markerComment)" v-mathml></div>
        </div>
    </div>
</template>

<script>
// import quillEditor from "@/components/quillEditor/index.vue"
import { mapState } from "vuex";
import * as config from "@/config/config";
import { ElMessageBox, ElMessage } from 'element-plus';
export default {
    name: "GjkcH5Composition",
    components: {
        // quillEditor
    },
    props: {
        questionInfo: {},
        isShowScoring: {
            default: false
        },
        questionTypeName: {
            default: "作文题"
        },
        testType: {},
        //  用于错题展示隐藏用户答案信息等
        hideUserAnswer: {
            default: false,
        },
        isChallenge: {},
        showAnswer: {}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
        // 添加计算属性实时转换
        transformedImageList() {
            if (!this.topicInfo.doAnswer?.imageList) return [];
            return this.topicInfo.doAnswer.imageList.map(item => {
                return item.response?.data?.url || item.url;
            });
        }
    },

    data() {
        return {
            topicInfo: {},
            uploadUrl: "",
            activeTab: 'text', // 当前激活的tab
            hasTextContent: false, // 是否有文本内容
            hasImageContent: false, // 是否有图片内容
            previousTab: 'text', // 记录前一个tab
        };
    },
    watch: {
        // 监听计算属性的变化，实时更新到 image
        transformedImageList: {
            handler(newUrls) {
                if (this.topicInfo.doAnswer) {
                    this.topicInfo.doAnswer.image = newUrls;
                }
            },
            immediate: true
        },
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                    this.checkContentStatus(); // 添加这行
                    this.normalizeDoAnswer();
                }
            },
            deep: true,
            immediate: true
        },
    },

    mounted() {
        this.uploadUrl = config.COMMON_UPLOAD_URL;
        this.setRecordTimeInterval();
        this.checkContentStatus(); // 添加这行
    },
    beforeUnmount() {
        if (this.recordTimeInterval) {
            clearInterval(this.recordTimeInterval);
            this.recordTimeInterval = null;
        }
    },

    methods: {
        // 标准化 doAnswer 数据格式
        normalizeDoAnswer() {
            // 确保 doAnswer 是对象
            if (typeof this.topicInfo.doAnswer === 'string') {
                try {
                    this.topicInfo.doAnswer = JSON.parse(this.topicInfo.doAnswer);
                } catch (e) {
                    console.error('解析 doAnswer 失败', e);
                    this.topicInfo.doAnswer = this.initializeDoAnswer();
                }
            }

            // 判断是否回答过
            if (this.topicInfo.courseExamRecordId) {
                // 同样处理 questionContext.doAnswer
                if (typeof this.topicInfo.questionContext.doAnswer === 'string') {
                    try {
                        this.topicInfo.questionContext.doAnswer = JSON.parse(this.topicInfo.questionContext.doAnswer);
                    } catch (e) {
                        console.error('解析 questionContext.doAnswer 失败', e);
                        this.topicInfo.questionContext.doAnswer = this.initializeDoAnswer();
                    }
                }
                this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
            }

            // 确保数据结构完整
            if (!this.topicInfo.doAnswer) {
                this.topicInfo.doAnswer = this.initializeDoAnswer();
            }
            if (!this.topicInfo.doAnswer.imageList) {
                this.topicInfo.doAnswer.imageList = [];
            }
            if (!this.topicInfo.doAnswer.image) {
                this.topicInfo.doAnswer.image = [];
            }
        },

        // 初始化 doAnswer 数据结构
        initializeDoAnswer() {
            return {
                title: '',
                content: '',
                image: [],
                imageList: []
            };
        },
        // 判断是否完成
        checkIsFinish() {
            if (!this.topicInfo.doAnswer) {
                return false;
            }

            const hasTitle = !this.$Tools.empty(this.topicInfo.doAnswer.title);
            const hasContent = !this.$Tools.empty(this.topicInfo.doAnswer.content);
            const hasImage = !this.$Tools.empty(this.topicInfo.doAnswer.image) &&
                this.topicInfo.doAnswer.image.length > 0;

            return hasTitle || hasContent || hasImage;
        },
        // 更新完成状态
        updateFinishStatus() {
            if (this.topicInfo.questionContext) {
                this.topicInfo.questionContext.isFinish = this.checkIsFinish();
            }
        },
        viewTopicInfo() {
            // 保持 image 为数组格式，但提取 URL 用于其他用途
            const image = this.topicInfo.doAnswer.imageList.map(item => {
                return item.response?.data?.url || item.url;
            });

            // 如果需要将 URLs 存储到其他地方
            this.topicInfo.doAnswer.image = image; // 新增一个字段存储 URLs
        },
        // 检查内容状态
        checkContentStatus() {
            if (!this.topicInfo.doAnswer) {
                this.topicInfo.doAnswer = {
                    title: '',
                    content: '',
                    image: []
                };
            }
            this.hasTextContent = !!(this.topicInfo.doAnswer.title || this.topicInfo.doAnswer.content);
            this.hasImageContent = !!(this.topicInfo.doAnswer.image && this.topicInfo.doAnswer.image.length > 0);
        },

        // 处理文本输入
        handleTextInput() {
            this.hasTextContent = !!(this.topicInfo.doAnswer?.title || this.topicInfo.doAnswer?.content);
            // 触发答案保存
            this.updateFinishStatus();
        },

        // 处理图片上传成功
        handleImageUploadSuccess() {
            this.hasImageContent = true;
            // 触发答案保存
            this.updateFinishStatus();
        },

        // 处理图片数量超出限制
        handleExceed(files, fileList) {
            ElMessage.warning(`最多只能上传 3 张图片，当前已选择 ${files.length + fileList.length} 张`);
        },

        // 添加 beforeTabLeave 方法
        async beforeTabLeave(activeName, oldActiveName) {
            // 如果从文本切换到图片，且有文本内容
            if (oldActiveName === 'text' && activeName === 'image' && this.hasTextContent) {
                try {
                    await ElMessageBox.confirm(
                        '切换至图片模式后，当前文本编辑的内容将不予以保留，是否确认切换？',
                        '提示',
                        {
                            confirmButtonText: '确认切换',
                            cancelButtonText: '取消',
                            type: 'warning',
                        }
                    );

                    // 用户确认切换，清空文本内容
                    if (this.topicInfo.doAnswer) {
                        this.topicInfo.doAnswer.title = '';
                        this.topicInfo.doAnswer.content = '';
                    }
                    this.hasTextContent = false;
                    return true; // 允许切换

                } catch (error) {
                    console.log('用户取消切换到图片tab');
                    return false; // 阻止切换
                }
            }
            // 如果从图片切换到文本，且有图片内容
            else if (oldActiveName === 'image' && activeName === 'text' && this.hasImageContent) {
                try {
                    await ElMessageBox.confirm(
                        '切换至文本模式后，当前上传的图片将不予以保留，是否确认切换？',
                        '提示',
                        {
                            confirmButtonText: '确认切换',
                            cancelButtonText: '取消',
                            type: 'warning',
                        }
                    );

                    // 用户确认切换，清空图片内容
                    if (this.topicInfo.doAnswer) {
                        this.topicInfo.doAnswer.image = [];
                    }
                    this.hasImageContent = false;
                    return true; // 允许切换

                } catch (error) {
                    console.log('用户取消切换到文本tab');
                    return false; // 阻止切换
                }
            }

            // 其他情况允许切换
            return true;
        },
        setRecordTimeInterval() {
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                this.recordTimeInterval = setInterval(() => {
                    if (this.topicInfo.answerSection == null) {
                        this.topicInfo.answerSection = 1;
                    } else {
                        this.topicInfo.answerSection++;
                    }
                    // 按每题作答时间提交
                    if (this.testExamInfo.otherRule.timeType == 2) {
                        this.$emit("answerQuestion", this.topicInfo);
                        // 当作答时间超过设定时间，该题设置为已完成并且不给作答
                        if (
                            this.topicInfo.answerSection >=
                            this.testExamInfo.otherRule.perQuestionTime
                        ) {
                            this.topicInfo.questionContext.isFinish = true;
                            this.$emit("answerQuestion", this.topicInfo);
                            setTimeout(() => {
                                this.$emit("showAnalysis", true);
                            }, 1000)
                            if (this.recordTimeInterval) {
                                clearInterval(this.recordTimeInterval);
                                this.recordTimeInterval = null;
                            }
                        }
                    }
                    // 判断当提交后定时器关闭 
                    else if (this.isShowScoring || this.topicInfo.showAnalysis) {
                        if (this.recordTimeInterval) {
                            clearInterval(this.recordTimeInterval);
                            this.recordTimeInterval = null;
                        }
                    }
                }, 1000);
            }
        },
        getIsShow(showId) {
            let flag = false;
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
                    if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
                        flag = true;
                    }
                }
            }
            return flag
        },
        getAudioUrl(info) {
            let ruleInfo = this.$Tools.jsonDecode(info);
            if (!this.$Tools.empty(ruleInfo)) {
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        // 富文本获取内容
        getAnswer(info) {
            // console.log(info,33333333);
            this.topicInfo.doAnswer = info;
            this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer;   // 保存答案
            this.topicInfo.questionContext.isFinish = !this.$Tools.empty(this.topicInfo.questionContext.doAnswer);   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        },
        getCompositionCount() {
            console.log(this.topicInfo.otherRule)
            if (!this.$Tools.empty(this.topicInfo.otherRule)) {
                let ruleInfo = this.$Tools.jsonDecode(this.topicInfo.otherRule);
                // return `${ruleInfo.compositionRule?.minWordCount}~${ruleInfo.compositionRule?.maxWordCount}`
                return {
                    minWordCount: ruleInfo.compositionRule?.minWordCount,
                    maxWordCount: ruleInfo.compositionRule?.maxWordCount,
                }
            }
        },
        handlePictureCardPreview(uploadFile) {
            this.dialogImageUrl = uploadFile.url;
            this.dialogVisible = true;
        },
        handleRemove(uploadFile) {
            console.log(uploadFile);
            this.checkContentStatus(); // 添加这行
            this.$nextTick(() => {
                this.updateFinishStatus();
                this.getAnswer(this.topicInfo.doAnswer); // 触发答案保存
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        // width: 45px;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }

        .count_num {
            color: #FF8300;
            font-size: 12px;
        }

        :deep(.el-tabs__nav) {
            float: right;
        }

        :deep(.el-tabs__item.is-active) {
            color: #13D6AA;
        }

        .input_title {
            :deep(.el-input__wrapper) {
                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                cursor: default;
                line-height: 60px;
                font-size: 18px;

                .el-input__inner {
                    cursor: default !important;
                    text-align: center;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding: 10px 0;
                }
            }
        }

        .input_content {
            :deep(.el-textarea__inner) {
                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
            }
        }

        // .upload_box {
        :deep(.el-upload--picture-card) {
            width: 96px;
            height: 96px;
        }

        :deep(.el-upload-list--picture-card .el-upload-list__item) {
            width: 96px;
            height: 96px;
        }

        // }
        .upload_tips {
            font-size: 14px;
            color: #CFCFCF;
        }


    }
}

:deep(.el-input__inner) {
    text-align: center;
}

.composition_image {
    width: 96px;
    height: 96px;
    border-radius: 12px;
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    // padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .top_answer {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                top: 16px;
                left: 0;
            }
        }
    }

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}

.marker_info {
    width: 100%;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;

    .marker_label {
        font-size: 14px;
        color: #999999;
    }
}
</style>